import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import {
  extraExpensesControllerCreate,
  extraExpensesControllerDelete,
  extraExpensesControllerFindAll,
  ExtraExpensesControllerFindAll$Params,
  extraExpensesControllerUpdate,
} from '@klubovna/api-client';
import { CreateExtraExpenseDto, ExtraIngredientExpense, UpdateExtraExpenseDto } from '@klubovna/api-client';
import { PaginatedResponse, toPaginatedResponse } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ExtraExpensesApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  findAll(params?: ExtraExpensesControllerFindAll$Params): Observable<PaginatedResponse<ExtraIngredientExpense>> {
    return extraExpensesControllerFindAll(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => toPaginatedResponse<ExtraIngredientExpense>(response.body)));
  }

  create(dto: CreateExtraExpenseDto): Observable<ExtraIngredientExpense> {
    return extraExpensesControllerCreate(this.http, this.apiConfig.rootUrl, { body: dto })
      .pipe(map(response => response.body as ExtraIngredientExpense));
  }

  update(id: string, dto: UpdateExtraExpenseDto): Observable<ExtraIngredientExpense> {
    return extraExpensesControllerUpdate(this.http, this.apiConfig.rootUrl, { id, body: dto })
      .pipe(map(response => response.body as ExtraIngredientExpense));
  }

  delete(id: string): Observable<void> {
    return extraExpensesControllerDelete(this.http, this.apiConfig.rootUrl, { id })
      .pipe(map(() => undefined));
  }
}
